export const CSV_ENRICHMENT_BTN = "si.my-lists.section.enrichment.dropdown.option.enrichment";

export const PREPARING_MAIN_TEXT = "si.my-lists.section.enrichment.modal.preparing.title";
export const PREPARING_HELP_TEXT = "si.enrichment.modal.preparing.help";
